import React from "react";
import { useSelector } from "react-redux";
import CartProduct from "./CartProduct";

export default function Cart() {
  const cart = useSelector((state) => state.cart);
  return cart.map((item) => <CartProduct key={item.name} {...item} />);
}
